import { Link } from "react-router-dom";
import Button from "../Button/Button";
import Typography from "../Typography";

/**
 * Full-page “permission denied” state — same layout and styling as {@link PageNotFound}.
 *
 * @param {object} props
 * @param {string} [props.title="You don't have permission"]
 * @param {string} [props.description]
 * @param {string} [props.to="/dashboard"] — react-router `to` for the primary action link
 * @param {string} [props.buttonLabel="Go to Dashboard"]
 */
const PermissionDenied = ({
  title = "You don't have permission",
  description = "You don't have permission to access this page or resource. If you believe this is a mistake, contact your administrator.",
  to = "/dashboard",
  buttonLabel = "Go to Dashboard",
}) => {
  return (
    <div className="page-not-found-container">
      <div className="text-center">
        <Typography variant="h1" className="page-not-found-404">
          403
        </Typography>
        <Typography variant="h2" className="page-not-found-title">
          {title}
        </Typography>
        <Typography variant="text1" className="page-not-found-description">
          {description}
        </Typography>
        <Link to={to}>
          <Button variant="primary" size="lg">
            {buttonLabel}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PermissionDenied;
